module.exports = __webpack_public_path__ + "img/login-dark.f58b443b.svg";